import { API_STATES } from "@/helpers";
const state = {
  importFileState         : API_STATES.NOT_REQUESTED,
  importFileError         : null,
  importScheduleFileState : API_STATES.NOT_REQUESTED,
  importScheduleFileError : null,
};

export default state;
